/* JapanSolved™ Icon Topic Link Map v1
   Icons are decorative by default. Links activate only when a slot asks for linking:
   data-jsi-clickable="true" with data-jsi-href, data-jsi-link-key, or data-jsi-link-mode="auto".
*/
(function () {
  'use strict';
  window.JapanSolvedIconLinkMap = {
  "version": "2026-07-05.icon-link-map.v1",
  "siteBaseUrl": "https://japansolved.com",
  "byKey": {
    "arts-antiques-provenance": "https://japansolved.com/pages/japan-art-antiques-authentication-provenance",
    "proxy-shopping-qa": "https://japansolved.com/pages/japan-proxy-shopping-quality-assurance",
    "private-buyer": "https://japansolved.com/pages/japan-private-buyer-proxy-execution-desk",
    "private-sourcing": "https://japansolved.com/pages/japan-private-sourcing-collector-acquisition-desk",
    "large-cargo": "https://japansolved.com/pages/japan-large-cargo-shipping-logistics",
    "cultural-asset-intelligence": "https://japansolved.com/pages/japan-cultural-asset-luxury-collectibles-intelligence",
    "watch-service": "https://japansolved.com/pages/japan-watch-servicing-warranty-proxy",
    "sword-export": "https://japansolved.com/pages/japan-sword-export-compliance",
    "bonsai-export": "https://japansolved.com/pages/japan-bonsai-export-compliance",
    "jdm-export": "https://japansolved.com/pages/japan-jdm-export-inspection",
    "lost-item": "https://japansolved.com/pages/japan-lost-item-recovery-return-coordination",
    "missing-person": "https://japansolved.com/pages/japan-missing-person-welfare-search-coordination",
    "jdm-parts": "https://japansolved.com/pages/japan-jdm-parts-wheels-tuning-acquisition",
    "jewelry-shopping": "https://japansolved.com/pages/japan-jewelry-shopping-proxy-personal-shopper",
    "ginza-luxury": "https://japansolved.com/pages/japan-ginza-luxury-brand-personal-shopping",
    "preloved-vintage-luxury": "https://japansolved.com/pages/japan-preloved-vintage-luxury-shopping",
    "vintage-thrift": "https://japansolved.com/pages/japan-vintage-thrift-flea-market-guided-shopping",
    "art-gallery-shopping": "https://japansolved.com/pages/japan-art-antiques-gallery-guided-shopping",
    "medical-tourism": "https://japansolved.com/pages/japan-medical-tourism-entourage-support",
    "beauty-longevity": "https://japansolved.com/pages/japan-beauty-longevity-product-sourcing-compliance",
    "sourcing-hub": "https://japansolved.com/pages/japansolved-sourcing-procurement-export-hub",
    "logistics-hub": "https://japansolved.com/pages/japansolved-logistics-local-representation-hub",
    "ticket-access": "https://japansolved.com/pages/japan-ticket-event-entertainment-access",
    "reservation-concierge": "https://japansolved.com/pages/japan-restaurant-activity-reservation-concierge",
    "private-travel-companion": "https://japansolved.com/pages/japan-private-travel-companion-sabbatical-reset",
    "vip-cultural-navigation": "https://japansolved.com/pages/japan-vip-travel-navigation-cultural-support",
    "bespoke-experience": "https://japansolved.com/pages/japan-bespoke-experience-custom-itinerary",
    "private-cultural-experiences": "https://japansolved.com/pages/private-cultural-experiences-japan-local-access",
    "nightlife-safety": "https://japansolved.com/pages/japan-nightlife-companion-safety-support",
    "personal-shopping-styling": "https://japansolved.com/pages/japan-personal-shopping-styling-companion-support",
    "celebrity-access": "https://japansolved.com/pages/japan-celebrity-concierge-private-access",
    "travel-access-hub": "https://japansolved.com/pages/japan-travel-cultural-experience-access-hub",
    "follow-up": "https://japansolved.com/pages/follow-up-on-existing-request"
  },
  "byCategory": {
    "logistics-representation": "logistics-hub",
    "sourcing-procurement": "sourcing-hub",
    "travel-cultural-access": "travel-access-hub",
    "travel-access-cases": "travel-access-hub",
    "travel-movement": "vip-cultural-navigation",
    "medical-due-diligence": "medical-tourism",
    "beauty-longevity": "beauty-longevity",
    "property-relocation": "logistics-hub",
    "privacy-discretion": "follow-up",
    "sensitive-matters": "follow-up",
    "secret-matter-cases": "follow-up",
    "japan-cultural-access": "private-cultural-experiences",
    "case-review": "follow-up",
    "advisory-intelligence": "follow-up",
    "verification-gap": "proxy-shopping-qa",
    "execution-support": "logistics-hub",
    "brand-logo": "travel-access-hub"
  },
  "byPillar": {
    "cargo-execution": "large-cargo",
    "local-representation": "logistics-hub",
    "sourcing": "sourcing-hub",
    "private-buyer": "private-buyer",
    "procurement-routing": "sourcing-hub",
    "asset-intelligence": "cultural-asset-intelligence",
    "capital-review": "cultural-asset-intelligence",
    "risk-screening": "follow-up",
    "intelligence": "follow-up",
    "review-routing": "follow-up",
    "due-diligence": "follow-up",
    "cultural-navigation": "vip-cultural-navigation",
    "access-coordination": "travel-access-hub",
    "concierge-presence": "private-travel-companion",
    "discretion": "follow-up",
    "trust-protection": "proxy-shopping-qa",
    "privacy-routing": "follow-up",
    "native-intake": "follow-up",
    "paid-routing": "follow-up",
    "route-intelligence": "reservation-concierge",
    "coordination": "reservation-concierge",
    "execution-support": "logistics-hub"
  },
  "byWing": {
    "review-intelligence": "follow-up",
    "general-japansolved-system": "travel-access-hub",
    "travel-cultural-access": "travel-access-hub",
    "sensitive-discreet-routing": "follow-up",
    "logistics-local-representation": "logistics-hub",
    "native-intake-system": "follow-up",
    "property-relocation": "logistics-hub",
    "sourcing-procurement-export": "sourcing-hub",
    "brand-system": "travel-access-hub",
    "business-market-entry": "follow-up",
    "asset-capital-intelligence": "cultural-asset-intelligence"
  }
};
})();
